import { useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { CustomRadio } from '../../../../lib/CustomRadio';
import TextInput from '../../../../lib/TextField';
import { RootStateType } from '../../../../redux-store/reducers';
import { FORM_15GH } from '../../../../utils/constants';
const { dashboard, common } = en;

function UpdateForm15(props: any) {
    const [formOption, setOption] = useState<string>('');
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdateForm15.UpdateForm15Heading} />
            <div className="curved-bg-content form15-main">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src="/images/change-email-img.png"
                            alt="icon"
                        />
                        <h6>{dashboard.UpdateForm15.panDetails}</h6>
                        <TextInput
                            variant="outlined"
                            label="PAN"
                            name="pan"
                            value={props.pan}
                            disabled
                        />
                        {/* {isAssessedUnderTaxAct === 'Y' && ( */}
                        <CustomRadio
                            title={dashboard.UpdateForm15.radioHeading}
                            name="select-form15"
                            list={[
                                {
                                    label: dashboard.UpdateForm15.form15G,
                                    value: '15G',
                                },
                                {
                                    label: dashboard.UpdateForm15.form15H,
                                    value: '15H',
                                },
                            ]}
                            selectedValue={formOption}
                            handleRadioChange={(value: string) => setOption(value)}
                        />
                        {/* )} */}
                    </div>
                    <FaqLink section={FORM_15GH} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        {!!formOption && (
                            <SubmitButton
                                onClick={() =>
                                    props.history.push('update-form15-list', { type: formOption })
                                }
                                label={dashboard.UpdateForm15.proceedBtn}
                                className="customBtn"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {})(UpdateForm15);
